<template>
  <b-tabs>
    <b-tab>
      <template slot="title">
        <i class='icon-list'></i>
      </template>

      <b-list-group-item class="text-center font-weight-bold bg-light text-uppercase small" style="padding: 0px 0px 0px 0px">
        <b-input-group>
          <b-form-input v-model="searchText" type="text" placeholder="Ricerca"></b-form-input>
          <b-input-group-append @click="cancelSearch" style="cursor: pointer;"><b-input-group-text><i class="fa fa-times"></i></b-input-group-text></b-input-group-append>
        </b-input-group>
      </b-list-group-item>
      <b-list-group-item @click="allClick" class="text-center font-weight-bold bg-light text-uppercase small" :style="{textDecoration: !selectedContract ? 'underline' : 'none', cursor: 'pointer'}">
        <i class="fa fa-angle-right"></i> TUTTI <i class="fa fa-angle-left"></i>
      </b-list-group-item>
      <Fleet v-for="fleet in filteredFleets" :key="fleet.id" :fleet="fleet" :searching="searchText.length > 0" />
    </b-tab>
    <b-tab v-if="selectedContract" :title-link-class="selectedContract.alias.length > 0 ? {} : null">
      <template slot="title">
        <i class='icon-speedometer'></i> {{ selectedContract.alias }}
      </template>
      <div class="p-3">
        <h6>Veicolo: {{ selectedContract.alias }}</h6>
        <h6>Targa: {{ selectedContract.plate.toUpperCase() }}</h6>
        <small v-if="selectedContract.livemonitor.online" style="color: #4dbd74;"><b>online</b></small><small v-else style="color: #f86c6b;"><b>offline</b></small>
        <hr>
        <div class="aside-options" style="overflow-y: auto;">
          <div class="clearfix mt-4">
            <small class="text-muted mr-3">
              <i class="icon-calendar"></i>&nbsp;&nbsp;{{ selectedContract.livemonitor.lastFixAt | formatDate }}
            </small><br/>
            <small class="text-muted">
              <i class="icon-location-pin"></i>&nbsp;&nbsp;<AddressGeocoder :latitude="selectedContract.livemonitor.latitude" :longitude="selectedContract.livemonitor.longitude" />
            </small>
          </div>
          <div class="clearfix mt-4">
            <small><b>Satelliti:</b>&nbsp;{{ selectedContract.livemonitor.satellites }}</small><br/>
            <small><b>Segnale GSM:</b>&nbsp;{{ parseInt(selectedContract.livemonitor.csq * 100 / 31) }} %</small><br/>
            <small><b>Altitudine:</b>&nbsp;{{ selectedContract.livemonitor.altitude }} m</small><br/>
            <small><b>GPS:</b>&nbsp;{{ convertDMS(selectedContract.livemonitor.latitude, selectedContract.livemonitor.longitude) }}</small><br/>
            <small><b>Chiave</b>&nbsp;<b-badge :variant="keyStatus.badge">{{ keyStatus.text }}</b-badge></small><br/>
            <small><b>Allarme</b>&nbsp;<b-badge :variant="alarmStatus.badge">{{ alarmStatus.text }}</b-badge></small><br/>
            <small><b>Blocco motore</b>&nbsp;<b-badge :variant="enginelockStatus.badge">{{ enginelockStatus.text }}</b-badge></small><br/>
            <div class="text-uppercase mb-1 mt-4">
              <small><b>Velocità: {{ selectedContract.livemonitor.speed }} km/h</b></small>
            </div>
            <b-progress height={} class="progress-xs" :variant="speed.badge" :value="speed.value"></b-progress>
          </div>
          <div class="clearfix mt-4">
            <small><b>Comandi</b></small>
          </div>
          <div style="padding-bottom: 60px;">
            <b-button :disabled="requestInProgress('LOCATE')" @click="requestClick('LOCATE')" size="lg" variant="primary" block>
              <i v-if="!requestInProgress('LOCATE')" class="fa fa-map"></i><i v-else class="fa fa-spinner fa-pulse fa-fw"></i>&nbsp;Localizza
            </b-button>
            <b-button :disabled="requestInProgress('ALARM')" @click="requestClick('ALARM', alarmStatus.parameters)" size="lg" :variant="alarmStatus.button" block>
              <i v-if="!requestInProgress('ALARM')" class="fa fa-lock"></i><i v-else class="fa fa-spinner fa-pulse fa-fw"></i>&nbsp;{{ alarmStatus.value ? 'Disattiva Allarme' : 'Attiva Allarme' }}
            </b-button>
            <b-button :disabled="requestInProgress('ENGINE_IMMOBILIZER')" @click="requestClick('ENGINE_IMMOBILIZER', enginelockStatus.parameters)" size="lg" :variant="enginelockStatus.button" block>
              <i v-if="!requestInProgress('ENGINE_IMMOBILIZER')" class="fa fa-bolt"></i><i v-else class="fa fa-spinner fa-pulse fa-fw"></i>&nbsp;{{ enginelockStatus.value ? 'Disattiva BM' : 'Attiva BM' }}
            </b-button>
          </div>
        </div>
      </div>
    </b-tab>
  </b-tabs>
</template>

<script>
import Fleet from '@/components/Fleet.vue'
import { mapGetters } from 'vuex'
import AddressGeocoder from '@/components/AddressGeocoder.vue';
import Vehicle from '@/components/Vehicle.vue';

import {
  SELECT_ALL_CONTRACTS,
} from '@/store/mutation-types';

export default {
  name: 'DefaultAside',
  data () {
    return {
      collapse: true,
      loading: false,
      searchText: '',
    }
  },
  components: {
    Fleet,
    AddressGeocoder,
    Vehicle,
  },
  methods: {
    cancelSearch: function() {
      this.searchText = '';
    },
    toDegreesMinutesAndSeconds: function (coordinate) {
        const absolute = Math.abs(coordinate);
        const degrees = Math.floor(absolute);
        const minutesNotTruncated = (absolute - degrees) * 60;
        const minutes = Math.floor(minutesNotTruncated);
        const seconds = Math.floor((minutesNotTruncated - minutes) * 60);

        return degrees + '° ' + minutes + '\' ' + seconds + '"';
    },
    convertDMS: function(lat, lng) {
        const latitude = this.toDegreesMinutesAndSeconds(lat);
        const latitudeCardinal = Math.sign(lat) >= 0 ? 'N' : 'S';

        const longitude = this.toDegreesMinutesAndSeconds(lng);
        const longitudeCardinal = Math.sign(lng) >= 0 ? 'E' : 'W';

        return latitudeCardinal + ' ' + latitude + ' - ' + longitudeCardinal + ' ' + longitude;
    },
    allClick: function() {
      this.$store.commit(SELECT_ALL_CONTRACTS);
    },
    requestClick: function(command, parameters) {
      this.loading = true;
      this.$store.dispatch('request', { command, parameters})
        .then(() => console.log('request inserted'))
        .catch((err) => {
          this.error = true;
          this.loading = false;
        });
    },
    notImplemented: function() {
      alert('Non ancora implementato');
    }
  },
  computed: {
    filteredFleets() {
      if (this.searchText.length === 0) {
        return this.fleets;
      }

      return this.fleets.map(f => {
        const contracts = f.contracts.filter(c =>
          c.alias.toLowerCase().includes(this.searchText.toLowerCase()) ||
          c.device.id.toString().toLowerCase().includes(this.searchText.toLowerCase()) ||
          c.plate.toLowerCase().includes(this.searchText.toLowerCase())
        );
        return Object.assign({}, f, { contracts })
      }).filter(f => f.contracts.length > 0);
    },
    speed() {
      const speedPerc = this.selectedContract.livemonitor.speed * 100 / 200;
      if (this.selectedContract.livemonitor.speed <= 50) {
        return { badge: 'success', value: speedPerc };
      } else if (this.selectedContract.livemonitor.speed > 50 && this.selectedContract.livemonitor.speed <= 130) {
        return { badge: 'warning', value: speedPerc };
      }

      return { badge: 'danger', value: speedPerc };
    },
    alarmStatus() {
      return (this.selectedContract.livemonitor.alarmStatus & 0x01) == 0x01
        ? { text: 'ON', badge: 'success', button: 'danger', value: true, parameters: '2' }
        : { text: 'OFF', badge: 'danger', button: 'success', value: false, parameters: '1' };
    },
    enginelockStatus() {
      return (this.selectedContract.livemonitor.alarmStatus & 0x40) == 0x40
        ? { text: 'ON', badge: 'success', button: 'danger', value: true, parameters: '2' }
        : { text: 'OFF', badge: 'danger', button: 'success', value: false, parameters: '1' };
    },
    keyStatus() {
      return (this.selectedContract.livemonitor.inputStatus & 0x01) == 0x01
        ? { text: 'ON', badge: 'success', value: true }
        : { text: 'OFF', badge: 'danger', value: false };
    },
    ...mapGetters([
        'contracts',
        'fleets',
        'selectedContract',
        'requestInProgress',
      ]),
  }
}
</script>
